import BigNumber from 'bignumber.js';
import { useContract } from './useContract';

import ERC20_ABI from 'contracts/erc20.json';
import { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';
import { useEthersProvider } from './useEthersProvider';
import user from 'stores/user';

export default function useTokenBalance(
    token: string,
    account?: string,
    intervalTime = 10000,
) {
    const [balance, setBalance] = useState(new BigNumber(0));
    const tokenContract = useContract(token, ERC20_ABI);
    const [loadingOnce, setLoadingOnce] = useState(false);
    const { address } = useAccount();
    const fetchAddress = account || address;
    const provider = useEthersProvider({
        chainId: user.chainId,
        account: fetchAddress,
    });

    async function getBalance() {
        if (token === '0x' && fetchAddress) {
            try {
                const balance = await provider.getBalance(fetchAddress);
                setBalance(new BigNumber(balance.toString()).shiftedBy(-18));
            } catch (e) {
                console.error(
                    `useTokenBalance error, token: 0x, account: ${fetchAddress} `,
                );
                console.error(e);
            }
        }
        if (!fetchAddress || !tokenContract?.address) return;

        try {
            const balance = await tokenContract?.balanceOf(fetchAddress);

            const decimals = await tokenContract?.decimals();

            if (balance && decimals) {
                setBalance(
                    new BigNumber(balance.toString()).shiftedBy(
                        -Number(decimals),
                    ),
                );
            }
        } catch (e) {
            console.error(
                `useTokenBalance error, token: ${token}, account: ${fetchAddress} `,
            );
            console.error(e);
        }
        setLoadingOnce(true);
    }

    useEffect(() => {
        getBalance();
        const interval = setInterval(() => {
            getBalance();
        }, intervalTime);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [fetchAddress, intervalTime, tokenContract]);
    useEffect(() => {
        setBalance(new BigNumber(0));
        setLoadingOnce(false);
    }, [fetchAddress]);

    return {
        balance,
        getBalance,
        loadingOnce,
    };
}
